import { ReturnableTypeEnum } from "./returnable-type";

/**
 * Rules the return form's parts have to agree on, kept in one place so they
 * cannot drift apart.
 */

/**
 * Goods-receipt returns are settled by the invoice that follows, so they carry
 * no prices of their own.
 */
export const hasPricing = (returnableType) =>
  returnableType === ReturnableTypeEnum.PURCHASE_INVOICE ||
  returnableType === ReturnableTypeEnum.NON_INVOICE;

/**
 * Unlike a sales return, a purchase return may only charge back expenses that
 * exist on a source purchase invoice — the backend rejects them for every other
 * source, and has no free-form form of them.
 */
export const supportsExpenses = (returnableType) =>
  returnableType === ReturnableTypeEnum.PURCHASE_INVOICE;
